Vue.component('test-3-crud-table', {
    template: `
        <div>
            <div class="alert alert-danger" v-if="errors.length">
                <p class="font-weight-bold">Please correct the following error(s):</p>
                <ul class="indented">
                    <li v-for="error in errors">{{ error }}</li>
                </ul>
            </div>
            <table class='table table-sm table-bordered table-striped table-hover'>
                <thead>
                    <tr>
                        <th>String</th>
                        <th class='text-right'>Float</th>
                        <th class='text-center'>Options</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <input class='form-control text-left' value='' v-model='inputValueString' />
                        </td>
                        <td class='text-right'>
                            <input class='form-control text-right' value='' v-model='inputValueFloat' />
                        </td>
                        <td class='text-center'>
                            <button class='btn btn-sm btn-primary' v-on:click='add'>Add</button>
                        </td>
                    </tr>
                    <test-3-crud-table-row
                        v-for="row in rows"
                        v-bind:key="row.id"
                        v-bind:row="row"
                        v-on:updateSubmit="handleUpdate"
                        v-on:remove="handleRemove"
                    ></test-3-crud-table-row>
                </tbody>
                <tfoot>
                    <tr>
                        <td>Total</td>
                        <td class='text-right'>{{ totalFloat }}</td>
                        <td></td>
                    </tr>
                </tfoot>
            </table>
        </div>
    `,
    data: function () {
        return {
            inputValueString: '',
            inputValueFloat: '',
            errors: [],
            rows: [
                { id: 1, valueString: 'Example 1', valueFloat: 15, isEditing = false },
                { id: 2, valueString: 'Example 2', valueFloat: 20, isEditing = false },
                { id: 3, valueString: 'Example 3', valueFloat: 30, isEditing = false }
            ]
        }
    },
    methods: {
        add: function () {

            //Clear any previous errors
            this.errors = [];

            //Validate the form
            this.validateString(this.inputValueString);
            this.validateFloat(this.inputValueFloat);
            
            //If no errors were found, continue
            if (!this.errors.length) {
                //Add the new row
                let newRow = { id = Apfco.getUUID(), valueString: this.inputValueString, valueFloat: Number(this.inputValueFloat), isEditing = false };
                this.rows.push(newRow);

                //Clear the input fields
                this.inputValueString = '';
                this.inputValueFloat = '';
            }
        },
        handleUpdate: function (rowId, inputValueString, inputValueFloat) {

            //Clear any previous errors
            this.errors = [];

            //Validate the form
            this.validateString(inputValueString);
            this.validateFloat(inputValueFloat);

            if (!this.errors.length) {

                //Get the row
                let rowIndex = this.rows.map(function (row) { return row.id; }).indexOf(rowId);
                let row = this.rows[rowIndex];

                row.valueString = inputValueString;
                row.valueFloat = Number(inputValueFloat);

                //Set editing back to false
                row.isEditing = false;
            }
            
        },
        handleRemove: function (rowId) {
            //See here: https://gist.github.com/scottopolis/6e35cf0d53bae81e6161662e6374da04
            let rowIndex = this.rows.map(function (row) { return row.id; }).indexOf(rowId);
            this.rows.splice(rowIndex, 1);
        },
        validateString: function(input) {
            if (!input) {
                this.errors.push("String is required.");
            }
            else if (input.length > 10) {
                this.errors.push('Max string length is 10 characters.');
            }
        },
        validateFloat: function (input) {
            if (!input) {
                this.errors.push('Float is required.');
            }
            else if (!Apfco.isNumeric(input)) {
                this.errors.push('Float is not a valid number.');
            }
            else if (input < 0.00 || input > 99.99) {
                this.errors.push('Float must be between 0.00 and 99.99');
            }
        }
    },
    computed: {
        totalFloat: function () {
            let sum = 0;
            return this.rows.reduce((sum, row) => sum + row.valueFloat, 0);
        }
    }
})